<script setup>
import {computed, onMounted, provide, ref, toRefs} from "vue";
import {nextRequestAnimationFrame} from "@utils/utils.js";

const data = defineProps({
  component: {
    type: Object,
    default: null
  },
  props: {
    type: Object,
    default: () => ({})
  },
  options: {
    type: Object,
    default: () => {}
  },
  setClose: {
    type: Function,
    default: () => {}
  },
  onClear: {
    type: Function,
    default: () => {}
  }
});

const options = computed(() => {
  const defaultOptions = {
    popupType: 'DEFAULT', // or 'BELONG'
    teleport: null,
    outerClose: false,
    shadow: true,
    customWrap: {}
  };
  return {...defaultOptions, ...data.options};
})

const {component, props, setClose, onClear} = toRefs(data);
const isOpen = ref(false);

setClose.value(close);

const handleMaskClick = (event) => {
  if (!options.value.outerClose) return;
  close();
};

function close() {isOpen.value = false}
function onAfterLeave() {onClear.value()}

provide('popup', {close})
onMounted(async () => isOpen.value = true)
</script>

<template lang="pug">
  // BELONG MODE
  template(v-if="options.popupType === 'BELONG'")
    teleport(:to="options.teleport || 'body'")
      .mask(v-if="isOpen" @click="handleMaskClick")
      transition(name="popup-fade" @after-leave="onAfterLeave")
        div(v-if="isOpen" @click.stop :style="options.customWrap")
          component(:is="component" v-bind="props")

  // DEFAULT MODE
  template(v-else)
      transition(name="popup-fade" @after-leave="onAfterLeave")
        #popup.mask(v-if="isOpen" :class="{shadow: options.shadow}" @click="handleMaskClick")
          .wrap
            component(:is="component", v-bind="props" @click.stop :style="options.customWrap")
</template>

<style scoped lang="sass">
@use '@assets/styles/common' as *
@use '@assets/styles/mixin' as *

.popup-fade-enter-active, .popup-fade-leave-active
  transition: opacity 0.125s ease-in-out
.popup-fade-enter-from, .popup-fade-leave-to
  opacity: 0

.mask
  +size(100vw,100vh)
  position: fixed
  top: 0
  left: 0
  z-index: 100000
  &.shadow
    background-color: rgba(25, 25, 25, 0.30)

  .wrap
    padding: 20px
    +flex(center)
    +size(100%)
</style>
